module.exports = __webpack_public_path__ + "img/7_affordable_and_clean_energy_color.f2c92f3d.svg";